import React from 'react'

import { GameWithUserInformation } from '../../../containers/GamesBlock/types'
import DesktopButtons from './Buttons/Desktop'
import MobileButtons from './Buttons/Mobile'
import { HoverWrapper } from './styles/HoverWrapper'

interface Props {
  game: GameWithUserInformation
  hover: boolean
  small: boolean
}

export function Hover({ hover, game, small }: Props) {
  return (
    <HoverWrapper hover={hover}>
      <MobileButtons slug={game.slug} />
      <DesktopButtons
        game={game}
        small={small}
      />
    </HoverWrapper>
  )
}
